<template>
  <tr :class="{ editable: editable }">
    <td>{{ service.id }}</td>
    <td>{{ service.name }}</td>

    <td>
      <input v-if="editable" v-model="service.description" class="form-control">
      <template v-else>
        {{ service.description }}
      </template>
    </td>

    <td>
      <BkpsCheckBox v-model="service.activeByDefault" :disabled="!editable"/>
    </td>

    <td>{{ service.createdAt | datetime }}</td>
    <td>{{ service.updatedAt | datetime }}</td>

    <td>
      <template v-if="editable">
        <button @click="save()" class="btn btn-success">Salvar</button>
        <button @click="cancel()" class="btn btn-outline">Cancelar</button>
      </template>

      <button v-else @click="editable=true" class="btn btn-outline">Editar</button>
    </td>
  </tr>

</template>

<script>
  import BkpsCheckBox from '@/components/shares/specialTag/BkpsCheckBox'
  import ModelMapper from '@/mixins/ModelMapper'
  import EntityProxy from '@/models/EntityProxy'

  export default {
    components: { BkpsCheckBox },
    created() {
      this.setClone()
    },
    data() {
      return {
        clone: '{}',
        editable: false,
        modelPathPrefix: 'admin',
        nameModel: 'Service'
      }
    },
    methods: {
      cancel() {
        const clone = JSON.parse(this.clone)
        Object.keys(clone).forEach(key => this.service[key] = clone[key])
        this.editable = false
      },
      save() {
        const service = EntityProxy.clone(this.service)

        this.asyncTemplateSave(service, {
          after: ({model}) => {
            this.$notify.add( 'Serviço atualizado com sucesso')
            Object.keys(model).forEach(key => this.service[key] = model[key])
            this.setClone()
            this.editable = false
          }
        })
      },
      setClone() {
        this.clone = JSON.stringify(this.service)
      }
    },
    mixins: [ModelMapper],
    name: 'Service',
    props: {
      service: { required: true, type: Object }
    }
  }
</script>

<style scoped>
  .editable > td {
    background: #a1d9e9;
  }
</style>
